import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { Activity, RefreshCw, Sparkles, MessageCircle } from "lucide-react";
import Loading from "./Loading";

function fmt(iso) { try { return new Date(iso).toLocaleString(); } catch { return "—"; } }

const KIND_META = {
  creation_posted: { Icon: Sparkles, label: "NEW CREATION", color: "sat-cyan" },
  creation_comment: { Icon: MessageCircle, label: "NEW COMMENT", color: "text-[color:var(--sat-text-dim)]" },
};

export default function AdminActivity() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const r = await api.get("/admin/activity?limit=100");
      setRows(r.data?.results || []);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "FAILED TO LOAD ACTIVITY");
    } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  return (
    <section data-testid="admin-activity">
      <div className="flex items-center gap-3 mb-4">
        <div className="sat-label sat-cyan flex items-center gap-2">
          <Activity size={12} /> RECENT PILOT ACTIVITY
        </div>
        <button onClick={load} className="sat-btn !py-2 !px-3 ml-auto" data-testid="admin-activity-refresh">
          <RefreshCw size={11} /> REFRESH
        </button>
      </div>
      {loading && <Loading message="LOADING ACTIVITY" />}
      {!loading && rows.length === 0 && (
        <div className="sat-label text-center py-10" data-testid="admin-activity-empty">NO EVENTS YET</div>
      )}
      <ul className="space-y-2" data-testid="admin-activity-list">
        {rows.map(e => {
          const meta = KIND_META[e.kind] || { Icon: Activity, label: (e.kind || "EVENT").toUpperCase(), color: "sat-cyan" };
          const p = e.payload || {};
          return (
            <li key={e.id} className="border border-[color:var(--sat-border)] bg-black/40 p-3 flex items-start gap-3"
                data-testid={`admin-activity-${e.id}`}>
              <meta.Icon size={13} className={meta.color} />
              <div className="flex-1 min-w-0">
                <div className={`sat-label ${meta.color}`}>{meta.label}</div>
                <div className="text-sm mt-0.5 truncate">
                  {e.kind === "creation_posted" && (
                    <>@{p.author} posted <span className="sat-cyan">"{p.title}"</span></>
                  )}
                  {e.kind === "creation_comment" && (
                    <>@{p.commenter} commented on <span className="sat-cyan">"{p.creation_title}"</span></>
                  )}
                  {!KIND_META[e.kind] && <span className="font-mono text-xs">{JSON.stringify(p).slice(0, 200)}</span>}
                </div>
                <div className="sat-label text-[color:var(--sat-text-dim)] mt-0.5">{fmt(e.created_at)}</div>
              </div>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
